import {Injectable} from "@angular/core";
import {
  ConfirmActionWithReviewsComponent
} from "./dialogs/confirm-action-with-reviews/confirm-action-with-reviews.component";
import {MatDialog} from "@angular/material/dialog";
import {ReviewDialogDataService} from "../../constants/review-dialog.constant";

@Injectable({
  providedIn: 'root'
})
export class CardsByQrRatingCommonService {

  constructor(
    private readonly matDialog: MatDialog,
    private readonly reviewDialogDataService: ReviewDialogDataService
  ) {
  }

  public onClickDeleteReview(action: () => void): void {
    const dialogData = this.reviewDialogDataService.getDeleteConfirmationData();
    const dialogRef = this.matDialog.open(ConfirmActionWithReviewsComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe({
      next: (isActionConfirmed: boolean) => {
        if (isActionConfirmed) {
          action();
        }
      }
    })
  }
}
